export const SET_LOCALE = 'LOCALE/SET'

export const SAVE_FAVORITE = 'FAVORITE/SAVE'
export const RESTORE_FAVORITE = 'FAVORITE/RESTORE'
export const DELETE_FAVORITE = 'FAVORITE/DELETE'
export const GET_USERLIST = 'USERLIST/GET'

export const SUBMIT_REQUEST = 'REQUEST/SUBMIT'

export const GET_FLOW = 'FLOW/GET'

export const GET_TASKS = 'TASKS/GET'

export const PUSH_REGISTER_DEVICE = 'PUSH/REGISTER/DEVICE'
export const PUSH_GET_MESSAGE = 'PUSH/GET/MESSAGE'
export const PUSH_DELETE_MESSAGE = 'PUSH/DELETE/MESSAGE'

export const SAVE_USER_INFO = 'USER/INFO/SAVE'


// WEBPACK FOOTER //
// ./src/store/mutation_types.js